import type {
  CreateCustomCardIntegrationApiArg,
  UpdateCustomCardIntegrationApiArg,
} from 'lib-shared-types-api';

export function transformCustomCardIntegrationArg(
  card: CreateCustomCardIntegrationApiArg | UpdateCustomCardIntegrationApiArg,
): Record<string, unknown> {
  const { integration_type, ...rest } = card;

  if (integration_type === 'salesforce') {
    return {
      integration_type: 'salesforceusernamepasswordflow',
      ...rest,
    };
  }

  return card;
}
